export default __webpack_public_path__ + "static/bienvenido-7c6cb7c94bee31277259806643f83d4f.png";